import { render, staticRenderFns } from "./EcommercePlainList.vue?vue&type=template&id=4c6695ae&"
import script from "./EcommercePlainList.vue?vue&type=script&lang=js&"
export * from "./EcommercePlainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports